<div class="last-activity-panel">

  <div class="last-activity-header">
    <h3 class="last-activity-title">{{translationsService.translate(settings?.Title) || 'Zadnja aktivnost'}}</h3>
    <a class="last-activity-view-all" [href]="settings?.Url || '#'">Prikaži vse →</a>
  </div>

  <div class="last-activity-list">
    @for (result of searchResults; track result; let i = $index) {
      <div class="last-activity-item" (click)="navigateToDetails(result.OriginalObject)">
        <div class="last-activity-icon activity-icon-{{i % 4}}"></div>
        <div class="last-activity-content">
          @for (prop of activeProps; track prop) {
            @if (prop.DataType === 'string') {
              <p class="last-activity-name">{{result[prop.Name]}}</p>
            }
            @if (prop.DataType === 'datetime') {
              <p class="last-activity-time">{{result[prop.Name] | date: 'dd.MM.yyyy HH:mm'}}</p>
            }
          }
        </div>
      </div>
    }
  </div>

</div>
